<tr [ngClass]="{'option_row--set': !!itemTree.bookingType}">
  <td easEditorBookingItemInheritableTypeHeader [inheritableType]="!itemTree.bookingType ? 'empty' : 'set'" i18n>
    Booking type
  </td>
  <td>
    @if (!itemTree.bookingType) {
      <span class="text-muted" i18n>
      Not set
    </span>
    }
    @if (itemTree.bookingType) {
      <span>
        {{ bookingTypeName }}
      </span>
    }
    <button mat-icon-button
      aria-label="Edit booking type"
      i18n-aria-label
      (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </td>
  <td>
    @if (!!itemTree.bookingType) {
      <eas-editor-booking-item-inheritable-type-badge [inheritableType]="'set'">
      </eas-editor-booking-item-inheritable-type-badge>
    }
  </td>
</tr>
